import {Stack, Typography, Paper, Link, Box, IconButton, Button, useTheme} from '@mui/material';
import {Clear} from '@mui/icons-material';
import {BannerType} from 'app/types/Shared';
import React from 'react';

type BannerProps = {
  type: BannerType;
  onClose?: () => void;
  title: string;
  subtitle?: string;
  link?: string;
  linkText?: string;
  onLinkClick?: () => void;
  onButtonClick?: () => void;
  button?: string;
  width?: number | string;
  height?: number | string;
  image?: string;
  open?: boolean;
};
const Banner = ({
  type,
  onClose,
  image,
  title,
  link,
  linkText,
  subtitle,
  onLinkClick,
  onButtonClick,
  button,
  open = true,
  width = 430,
  height = 205,
}: BannerProps) => {
  const theme = useTheme();

  const [showBanner, setShowBanner] = React.useState(open);

  const HandleClose = () => {
    if (onClose) {
      onClose();
      setShowBanner(false);
    } else {
      setShowBanner(false);
    }
  };

  return (
    <>
      {type === BannerType.Top ? (
        <Paper
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '40px',
            maxHeight: '40px',
            bgcolor: theme.palette.primary.main,
            borderRadius: 0,
          }}
        >
          <Stack direction='row' spacing={4} alignItems='center' justifyContent='center' flexGrow={1}>
            <Typography variant='h5' color='white'>
              {title}
            </Typography>
            {link && (
              <Link
                underline='none'
                color='white'
                sx={{'&:hover': {cursor: 'pointer'}, color: 'white', borderBottom: '1px solid white'}}
                href={link}
                target='_blank'
                rel='noopener noreferrer'
              >
                {linkText}
              </Link>
            )}
          </Stack>
          <Box display='flex' justifyContent='flex-end' pr={1}>
            <IconButton
              onClick={() => {
                onButtonClick && onButtonClick();
              }}
            >
              <Clear fontSize='small' sx={{color: 'white'}} />
            </IconButton>
          </Box>
        </Paper>
      ) : (
        <>
          {showBanner && (
            <Paper
              sx={{
                width: 'auto',
                height: 'auto',
                maxWidth: width,
                maxHeight: height,
                position: 'absolute',
                top: '15%',
                left: '25%',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                bgcolor: theme.palette.grey[200],
                zIndex: 9999,
                boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
                pb: 8,
              }}
            >
              <Stack
                direction='column'
                spacing={2}
                alignItems='center'
                justifyContent='flex-start'
                width='100%'
                px={'10px'}
                py={'10px'}
              >
                <Box width='100%' display='flex' justifyContent='flex-end'>
                  <IconButton sx={{padding: 0}} onClick={() => HandleClose()}>
                    <Clear fontSize='small' sx={{color: '#000000'}} />
                  </IconButton>
                </Box>
                {image && <img src={image} alt='banner' style={{width: '302px', height: '268px'}} />}
                <Typography variant='h1'>{title}</Typography>
                <Box width='45%'>
                  <Typography variant='h6' textAlign='center'>
                    {subtitle}
                  </Typography>
                </Box>
                {button && (
                  <Button
                    variant='contained'
                    onClick={() => {
                      setShowBanner(false);
                      onButtonClick && onButtonClick();
                    }}
                  >
                    {button}
                  </Button>
                )}
                {linkText && (
                  <Link
                    underline='none'
                    color='white'
                    sx={{'&:hover': {cursor: 'pointer'}, color: 'white', borderBottom: '1px solid white'}}
                    href={onLinkClick ? undefined : link}
                    onClick={() => onLinkClick && onLinkClick()}
                  >
                    {linkText}
                  </Link>
                )}
              </Stack>
            </Paper>
          )}
        </>
      )}
    </>
  );
};
export default Banner;
